import React from 'react';

// A right-pointing arrow with a stem and head (drawn as a single filled shape so
// it colors via `fill`, like the other icons). Flip with a 180deg rotate for a
// left arrow.
const SvgArrowRight = ({ style }: SvgArrowRightTypes) => (
	<svg style={style} viewBox="0 0 24 24">
		<path d="M2 10.5 H13 V6.5 L22 12 L13 17.5 V13.5 H2 Z" />
	</svg>
);

type SvgArrowRightTypes = {
	style?: React.CSSProperties;
};

export default SvgArrowRight;
